// Truncates to at most `max` whole characters. Iterating by code point (Array.from) rather than a raw
// slice or a UTF-16 maxlength is what keeps a trailing emoji whole instead of cut to a lone surrogate,
// and matches countCharacters so the "X/50" counter and the cap never disagree. Code-unit counterpart:
// clampToMaxCodeUnits, for the note's UTF-16-measured API cap.
const clampToMaxCharacters = (value, max) => {
    if (!value) {
        return value;
    }
    const codePoints = Array.from(value);
    if (codePoints.length <= max) {
        return value;
    }
    return codePoints.slice(0, max).join('');
};

export default clampToMaxCharacters;
